import React from "react";
import SubHeader from "../../../../atoms/SubHeader/SubHeader";
import "./Reviews.css";

const Reviews = () => {
  return (
    <div className="dashboard-home-wrapper">
      {/* <div className="dashmenu-style">
        <DashMenu toggleMenu={toggleMenu} showMenu={showMenu} />
      </div> */}
      <SubHeader title={"REVIEWS"}/>
    </div>
  );
};

export default Reviews;
